/**
 * Analytics extension logging utility
 * Provides consistent logging prefixes for all analytics-related components
 */
import { log } from "../../../util/log";
/**
 * Log function specifically for analytics extension components
 * Automatically prefixes all log messages with [ANALYTICS]
 *
 * @param level Log level
 * @param message Log message
 * @param metadata Optional metadata object
 */
export function analyticsLog(level, message, metadata) {
    log(level, `[ANALYTICS] ${message}`, metadata);
}
/**
 * Log function for specific analytics services (e.g., Mixpanel, GA4)
 * Prefixes with [ANALYTICS:SERVICE]
 *
 * @param service Service name (e.g., 'mixpanel', 'ga4')
 * @param level Log level
 * @param message Log message
 * @param metadata Optional metadata object
 */
export function analyticsServiceLog(service, level, message, metadata) {
    log(level, `[ANALYTICS:${service.toUpperCase()}] ${message}`, metadata);
}
